import { USER_ROLE } from '../../appConst'

export const isAdmin = (user) => user.role === USER_ROLE.ADMIN
export const isOperator = (user) => user.role === USER_ROLE.OPERATOR
